import { getAssessmentById } from '@/data/assessments'
import { AssessmentDetailPage } from './AssessmentDetailPage'

export function NetworkAssessment() {
  const assessment = getAssessmentById('network')!
  return <AssessmentDetailPage assessment={assessment} />
}
